class EmbeddingToolInfo {
  private static toolInfo: string[] = [];

  public static getToolInfo(): string {
    return EmbeddingToolInfo.toolInfo.join(", ");
  }

  public static isChemiTool(): boolean {
    // check if we have cached the tool info
    if (this.toolInfo.length === 0) {
      EmbeddingToolInfo.loadToolInfo();
    }

    if (EmbeddingToolInfo.toolInfo.length > 0) {
      return EmbeddingToolInfo.toolInfo[0] === "ChemiTool";
    }

    return false;
  }

  public static isChemiAnalysis(): boolean {
    // check if we have cached the tool info
    if (this.toolInfo.length === 0) {
      EmbeddingToolInfo.loadToolInfo();
    }

    if (EmbeddingToolInfo.toolInfo.length > 1) {
      return (
        EmbeddingToolInfo.isChemiTool() &&
        EmbeddingToolInfo.toolInfo[1] === "ChemiAnalysis"
      );
    }

    return false;
  }

  public static isToolOnWindows(): boolean {
    // check if we have cached the tool info
    if (this.toolInfo.length === 0) {
      EmbeddingToolInfo.loadToolInfo();
    }

    if (EmbeddingToolInfo.toolInfo.length > 2) {
      return EmbeddingToolInfo.toolInfo[2] === "WIN";
    }

    return false;
  }

  public static isToolOnMac(): boolean {
    // check if we have cached the tool info
    if (this.toolInfo.length === 0) {
      EmbeddingToolInfo.loadToolInfo();
    }

    if (EmbeddingToolInfo.toolInfo.length > 2) {
      return EmbeddingToolInfo.toolInfo[2] === "OSX";
    }

    return false;
  }

  private static loadToolInfo() {
    const auxToolInfo = localStorage.getItem("chemitool");

    if (
      auxToolInfo !== undefined &&
      auxToolInfo !== null &&
      auxToolInfo !== ""
    ) {
      EmbeddingToolInfo.toolInfo = auxToolInfo.split(" ");
    }
  }
}

export default EmbeddingToolInfo;
